import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ValidatorFn, Validators } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { GeneralLedger } from "projects/sepidz-web-framework/src/lib/models";
import { AccountBalanceKind, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";
import { SubLedgerDetailLedgerKind } from "../../models/subledger-detailledgerkind.model";
import { SubLedger } from "../../models/subledger.model";

@Component({
  selector: "subledger-form",
  templateUrl: "subledger-form.component.html",
  styleUrls: ["subledger-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubLedgerFormComponent extends BaseFormComponent<SubLedger> {
  private selectedgeneralLedgerCodeLen: number;
  private selectedSubLedgerCodeLen: number;
  formGroupIsOk: boolean = false;
  get detailLedgerLevel(): number {
    return this.missetup.getnumber("ACC", "DLLEVEL");
  }
  private _selectedLevel1Ids: number[] = [];
  get selectedLevel1Ids(): number[] {
    if (this.model && this.detailLedgerLevel > 0 && this._selectedLevel1Ids.length === 0 && this.model.SubLedgerDetailLedgerKinds) {
      this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 1).forEach((x) => {
        this._selectedLevel1Ids.push(x.DetailLedgerKindId);
      });
    }
    return this._selectedLevel1Ids;
  }
  set selectedLevel1Ids(valuse: number[]) {
    this._selectedLevel1Ids = valuse;
  }
  private _selectedLevel2Ids: number[] = [];
  get selectedLevel2Ids(): number[] {
    if (this.model && this.detailLedgerLevel > 1 && this._selectedLevel2Ids.length === 0 && this.model.SubLedgerDetailLedgerKinds) {
      this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 2).forEach((x) => {
        this._selectedLevel2Ids.push(x.DetailLedgerKindId);
      });
    }
    return this._selectedLevel2Ids;
  }
  set selectedLevel2Ids(valuse: number[]) {
    this._selectedLevel2Ids = valuse;
  }
  private _selectedLevel3Ids: number[] = [];
  get selectedLevel3Ids(): number[] {
    if (this.model && this.detailLedgerLevel > 2 && this._selectedLevel3Ids.length === 0 && this.model.SubLedgerDetailLedgerKinds) {
      this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 3).forEach((x) => {
        this._selectedLevel3Ids.push(x.DetailLedgerKindId);
      });
    }
    return this._selectedLevel3Ids;
  }
  set selectedLevel3Ids(valuse: number[]) {
    this._selectedLevel3Ids = valuse;
  }
  private _selectedLevel4Ids: number[] = [];
  get selectedLevel4Ids(): number[] {
    if (this.model && this.detailLedgerLevel > 4 && this._selectedLevel4Ids.length === 0 && this.model.SubLedgerDetailLedgerKinds) {
      this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 4).forEach((x) => {
        this._selectedLevel4Ids.push(x.DetailLedgerKindId);
      });
    }
    return this._selectedLevel4Ids;
  }
  set selectedLevel4Ids(valuse: number[]) {
    this._selectedLevel4Ids = valuse;
  }
  private _selectedLevel5Ids: number[] = [];
  get selectedLevel5Ids(): number[] {
    if (this.model && this.detailLedgerLevel > 4 && this._selectedLevel5Ids.length === 0 && this.model.SubLedgerDetailLedgerKinds) {
      this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 5).forEach((x) => {
        this._selectedLevel5Ids.push(x.DetailLedgerKindId);
      });
    }
    return this._selectedLevel5Ids;
  }
  set selectedLevel5Ids(valuse: number[]) {
    this._selectedLevel5Ids = valuse;
  }
  private _selectedLevel6Ids: number[] = [];
  get selectedLevel6Ids(): number[] {
    if (this.model && this.detailLedgerLevel > 5 && this._selectedLevel6Ids.length === 0 && this.model.SubLedgerDetailLedgerKinds) {
      this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 6).forEach((x) => {
        this._selectedLevel6Ids.push(x.DetailLedgerKindId);
      });
    }
    return this._selectedLevel6Ids;
  }
  set selectedLevel6Ids(valuse: number[]) {
    this._selectedLevel6Ids = valuse;
  }
  private _selectedLevel7Ids: number[] = [];
  get selectedLevel7Ids(): number[] {
    if (this.model && this.detailLedgerLevel > 6 && this._selectedLevel7Ids.length === 0 && this.model.SubLedgerDetailLedgerKinds) {
      this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 7).forEach((x) => {
        this._selectedLevel7Ids.push(x.DetailLedgerKindId);
      });
    }
    return this._selectedLevel7Ids;
  }
  set selectedLevel7Ids(valuse: number[]) {
    this._selectedLevel7Ids = valuse;
  }

  get HasDetailLedger1() {
    if (this.formGroup && this.formGroup.controls["HasDetailLedger1"]) return this.formGroup.controls["HasDetailLedger1"].value;
    return false;
  }
  get HasDetailLedger2() {
    if (this.formGroup && this.formGroup.controls["HasDetailLedger2"]) return this.formGroup.controls["HasDetailLedger2"].value;
    return false;
  }
  get HasDetailLedger3() {
    if (this.formGroup && this.formGroup.controls["HasDetailLedger3"]) return this.formGroup.controls["HasDetailLedger3"].value;
    return false;
  }
  get HasDetailLedger4() {
    if (this.formGroup && this.formGroup.controls["HasDetailLedger4"]) return this.formGroup.controls["HasDetailLedger4"].value;
    return false;
  }
  get HasDetailLedger5() {
    if (this.formGroup && this.formGroup.controls["HasDetailLedger5"]) return this.formGroup.controls["HasDetailLedger5"].value;
    return false;
  }
  get HasDetailLedger6() {
    if (this.formGroup && this.formGroup.controls["HasDetailLedger6"]) return this.formGroup.controls["HasDetailLedger6"].value;
    return false;
  }
  get HasDetailLedger7() {
    if (this.formGroup && this.formGroup.controls["HasDetailLedger7"]) return this.formGroup.controls["HasDetailLedger7"].value;
    return false;
  }
  constructor(
    private missetup: MisSetupService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private lookupservice: LookupService
  ) {
    super(selectorService, cd);
    this.missetup.getall();
  }
  async ngOnInit() {
    this.apiName = "SubLedger";
    this.label = this.translate("ClientApp.BackOffice.ACC.SubLedger.SubLedger");
    super.ngOnInit();
    this.setlen();
  }
  setdefault() {
    if (!this.model.BalanceKindId) {
      this.lookupservice
        .getLookupbyCode("ACC", "AccountBalanceKind", AccountBalanceKind.neutral)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.BalanceKindId = x.Id;
          this.model.BalanceKindCode = x.Code;
          this.model.BalanceKindTitle = x.Title;
          this.setValue("BalanceKindId", x.Id);
          this.setValue("BalanceKindCode", x.Code);
          this.setValue("BalanceKindTitle", x.Title);
        });
    }
    if (this.model.Active === undefined) {
      this.model.Active = true;
      this.setValue("Active", this.model.Active);
    }
    if (this.model.HasTrackNo === undefined) {
      this.model.HasTrackNo = false;
      this.setValue("HasTrackNo", this.model.HasTrackNo);
    }
    if (this.model.RequireTrackNo === undefined) {
      this.model.RequireTrackNo = false;
      this.setValue("RequireTrackNo", this.model.RequireTrackNo);
    }
  }
  addControl() {
    this.formGroupIsOk = false;
    this.setValue("DetailLedger1", this.selectedLevel1Ids);
    this.setValue("DetailLedger2", this.selectedLevel2Ids);
    this.setValue("DetailLedger3", this.selectedLevel3Ids);
    this.setValue("DetailLedger4", this.selectedLevel4Ids);
    this.setValue("DetailLedger5", this.selectedLevel5Ids);
    this.setValue("DetailLedger6", this.selectedLevel6Ids);
    this.setValue("DetailLedger7", this.selectedLevel7Ids);
    this.setValue("SubLedgerDetailLedgerKinds", this.model.SubLedgerDetailLedgerKinds);
    this.formGroupIsOk = true;
    this.cd.markForCheck();
  }
  setlen() {
    this.selectedgeneralLedgerCodeLen = this.missetup.getnumber("ACC", "PLLEN") + this.missetup.getnumber("ACC", "GLLEN");
    this.selectedSubLedgerCodeLen = this.missetup.getnumber("ACC", "SLLEN");
    if (this.selectedgeneralLedgerCodeLen === 0 && this.selectedSubLedgerCodeLen === 0)
      this.sts.showDialog("تنظیمات کدینگ حسابداری انجام نشده است.", "خطای تنظیم کدینگ");
  }
  onChange($event: GeneralLedger) {
    if ($event && $event.GroupLedgerId && this.isNewRow) {
      this.model.GeneralLedgerId = $event.Id;
      this.model.GeneralLedgerCode = $event.Code;
      this.model.GeneralLedgerTitle = $event.Title;
      this.setMaxCode();
    }
  }
  setMaxCode() {
    if (!this.selectedSubLedgerCodeLen || this.selectedSubLedgerCodeLen === 0) this.setlen();

    this.httpCommonService
      .getMaxCodeWithParameter(this.apiName, this.model.GeneralLedgerId, this.model.GeneralLedgerCode, this.selectedSubLedgerCodeLen)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.model["Code"] = data as number;
        }
        this.setdefault();
        if (this.formGroup && this.formGroup.controls["Code"]) this.formGroup.controls["Code"].setValue(data as number);
        this.setColumnAttribute();
      });
    if (this.columns && this.columns.length > 0) {
      var item = this.columns.filter((item) => item.name === "Code")[0];
      if (item) {
        item.maxLength = this.selectedgeneralLedgerCodeLen + this.selectedSubLedgerCodeLen;
        item.minLength = this.selectedgeneralLedgerCodeLen + 1;
      }
    }
  }
  isValidDetailLedgerKind() {
    if (!this.model.SubLedgerDetailLedgerKinds) this.model.SubLedgerDetailLedgerKinds = [];
    this._selectedLevel1Ids = this.formGroup.value.DetailLedger1;
    if (!this.formGroup.value.HasDetailLedger1) this._selectedLevel1Ids = null;
    if (this._selectedLevel1Ids && this._selectedLevel1Ids?.length > 0) {
      this._selectedLevel1Ids.forEach((x) => {
        let temp = this.model.SubLedgerDetailLedgerKinds.filter((sdk) => sdk.DetailLedgerKindId === x && sdk.DetailLedgerLevel === 1);
        if (!temp || temp.length <= 0) {
          let entity = <SubLedgerDetailLedgerKind>{};
          entity.DetailLedgerKindId = x;
          entity.SubLedgerId = this.model.Id;
          entity.DetailLedgerLevel = 1;
          entity.State = RowState.New;
          if (
            !this.model.SubLedgerDetailLedgerKinds.some(
              (x) => x.DetailLedgerLevel === entity.DetailLedgerLevel && x.DetailLedgerKindId == entity.DetailLedgerKindId
            )
          )
            this.model.SubLedgerDetailLedgerKinds.push(entity);
        }
      });
    }
    this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 1).forEach((item) => {
      if (this._selectedLevel1Ids && !this._selectedLevel1Ids.some((x) => x === item.DetailLedgerKindId)) {
        item.State = RowState.Delete;
      }
    });

    this._selectedLevel2Ids = this.formGroup.value.DetailLedger2;
    if (!this.formGroup.value.HasDetailLedger2) this._selectedLevel2Ids = null;
    if (this._selectedLevel2Ids && this._selectedLevel2Ids?.length > 0) {
      this._selectedLevel2Ids.forEach((x) => {
        let temp = this.model.SubLedgerDetailLedgerKinds.filter((sdk) => sdk.DetailLedgerKindId === x && sdk.DetailLedgerLevel === 2);
        if (!temp || temp.length <= 0) {
          let entity = <SubLedgerDetailLedgerKind>{};
          entity.DetailLedgerKindId = x;
          entity.SubLedgerId = this.model.Id;
          entity.DetailLedgerLevel = 2;
          entity.State = RowState.New;
          if (
            !this.model.SubLedgerDetailLedgerKinds.some(
              (x) => x.DetailLedgerLevel === entity.DetailLedgerLevel && x.DetailLedgerKindId == entity.DetailLedgerKindId
            )
          )
            this.model.SubLedgerDetailLedgerKinds.push(entity);
        }
      });
    }
    this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 2).forEach((item) => {
      if (this._selectedLevel2Ids && !this._selectedLevel2Ids.some((x) => x === item.DetailLedgerKindId)) {
        item.State = RowState.Delete;
      }
    });

    this._selectedLevel3Ids = this.formGroup.value.DetailLedger3;
    if (!this.formGroup.value.HasDetailLedger3) this._selectedLevel3Ids = null;
    if (this._selectedLevel3Ids && this._selectedLevel3Ids?.length > 0) {
      this._selectedLevel3Ids.forEach((x) => {
        let temp = this.model.SubLedgerDetailLedgerKinds.filter((sdk) => sdk.DetailLedgerKindId === x && sdk.DetailLedgerLevel === 3);
        if (!temp || temp.length <= 0) {
          let entity = <SubLedgerDetailLedgerKind>{};
          entity.DetailLedgerKindId = x;
          entity.SubLedgerId = this.model.Id;
          entity.DetailLedgerLevel = 3;
          entity.State = RowState.New;
          if (
            !this.model.SubLedgerDetailLedgerKinds.some(
              (x) => x.DetailLedgerLevel === entity.DetailLedgerLevel && x.DetailLedgerKindId == entity.DetailLedgerKindId
            )
          )
            this.model.SubLedgerDetailLedgerKinds.push(entity);
        }
      });
    }
    this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 3).forEach((item, index) => {
      if (this._selectedLevel3Ids && !this._selectedLevel3Ids.some((x) => x === item.DetailLedgerKindId)) {
        item.State = RowState.Delete;
      }
    });
    this._selectedLevel4Ids = this.formGroup.value.DetailLedger4;
    if (!this.formGroup.value.HasDetailLedger4) this._selectedLevel4Ids = null;
    if (this._selectedLevel4Ids && this._selectedLevel4Ids?.length > 0) {
      this._selectedLevel4Ids.forEach((x) => {
        let temp = this.model.SubLedgerDetailLedgerKinds.filter((sdk) => sdk.DetailLedgerKindId === x && sdk.DetailLedgerLevel === 4);
        if (!temp || temp.length <= 0) {
          let entity = <SubLedgerDetailLedgerKind>{};
          entity.DetailLedgerKindId = x;
          entity.SubLedgerId = this.model.Id;
          entity.DetailLedgerLevel = 4;
          entity.State = RowState.New;
          if (
            !this.model.SubLedgerDetailLedgerKinds.some(
              (x) => x.DetailLedgerLevel === entity.DetailLedgerLevel && x.DetailLedgerKindId == entity.DetailLedgerKindId
            )
          )
            this.model.SubLedgerDetailLedgerKinds.push(entity);
        }
      });
    }
    this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 4).forEach((item, index) => {
      if (this._selectedLevel4Ids && !this._selectedLevel4Ids.some((x) => x === item.DetailLedgerKindId)) {
        item.State = RowState.Delete;
      }
    });
    this._selectedLevel5Ids = this.formGroup.value.DetailLedger5;
    if (!this.formGroup.value.HasDetailLedger5) this._selectedLevel5Ids = null;
    if (this._selectedLevel5Ids && this._selectedLevel5Ids?.length > 0) {
      this._selectedLevel5Ids.forEach((x) => {
        let temp = this.model.SubLedgerDetailLedgerKinds.filter((sdk) => sdk.DetailLedgerKindId === x && sdk.DetailLedgerLevel === 5);
        if (!temp || temp.length <= 0) {
          let entity = <SubLedgerDetailLedgerKind>{};
          entity.DetailLedgerKindId = x;
          entity.SubLedgerId = this.model.Id;
          entity.DetailLedgerLevel = 5;
          entity.State = RowState.New;
          if (
            !this.model.SubLedgerDetailLedgerKinds.some(
              (x) => x.DetailLedgerLevel === entity.DetailLedgerLevel && x.DetailLedgerKindId == entity.DetailLedgerKindId
            )
          )
            this.model.SubLedgerDetailLedgerKinds.push(entity);
        }
      });
    }
    this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 5).forEach((item, index) => {
      if (this._selectedLevel5Ids && !this._selectedLevel5Ids.some((x) => x === item.DetailLedgerKindId)) {
        item.State = RowState.Delete;
      }
    });
    this._selectedLevel6Ids = this.formGroup.value.DetailLedger6;
    if (!this.formGroup.value.HasDetailLedger6) this._selectedLevel6Ids = null;
    if (this._selectedLevel6Ids && this._selectedLevel6Ids?.length > 0) {
      this._selectedLevel6Ids.forEach((x) => {
        let temp = this.model.SubLedgerDetailLedgerKinds.filter((sdk) => sdk.DetailLedgerKindId === x && sdk.DetailLedgerLevel === 6);
        if (!temp || temp.length <= 0) {
          let entity = <SubLedgerDetailLedgerKind>{};
          entity.DetailLedgerKindId = x;
          entity.SubLedgerId = this.model.Id;
          entity.DetailLedgerLevel = 6;
          entity.State = RowState.New;
          if (
            !this.model.SubLedgerDetailLedgerKinds.some(
              (x) => x.DetailLedgerLevel === entity.DetailLedgerLevel && x.DetailLedgerKindId == entity.DetailLedgerKindId
            )
          )
            this.model.SubLedgerDetailLedgerKinds.push(entity);
        }
      });
    }
    this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 6).forEach((item, index) => {
      if (this._selectedLevel6Ids && !this._selectedLevel6Ids.some((x) => x === item.DetailLedgerKindId)) {
        item.State = RowState.Delete;
      }
    });
    this._selectedLevel7Ids = this.formGroup.value.DetailLedger7;
    if (!this.formGroup.value.HasDetailLedger7) this._selectedLevel7Ids = null;
    if (this._selectedLevel7Ids && this._selectedLevel7Ids?.length > 0) {
      this._selectedLevel7Ids.forEach((x) => {
        let temp = this.model.SubLedgerDetailLedgerKinds.filter((sdk) => sdk.DetailLedgerKindId === x && sdk.DetailLedgerLevel === 7);
        if (!temp || temp.length <= 0) {
          let entity = <SubLedgerDetailLedgerKind>{};
          entity.DetailLedgerKindId = x;
          entity.SubLedgerId = this.model.Id;
          entity.DetailLedgerLevel = 7;
          entity.State = RowState.New;
          if (
            !this.model.SubLedgerDetailLedgerKinds.some(
              (x) => x.DetailLedgerLevel === entity.DetailLedgerLevel && x.DetailLedgerKindId == entity.DetailLedgerKindId
            )
          )
            this.model.SubLedgerDetailLedgerKinds.push(entity);
        }
      });
    }
    this.model.SubLedgerDetailLedgerKinds.filter((x) => x.DetailLedgerLevel === 7).forEach((item, index) => {
      if (this._selectedLevel7Ids && !this._selectedLevel7Ids.some((x) => x === item.DetailLedgerKindId)) {
        item.State = RowState.Delete;
      }
    });
    this.formGroup.controls["SubLedgerDetailLedgerKinds"].setValue(this.model.SubLedgerDetailLedgerKinds);
  }
  isValid() {
    if (!this.selectedgeneralLedgerCodeLen || this.selectedgeneralLedgerCodeLen === 0) this.setlen();
    this.isValidDetailLedgerKind();
    let result =
      this.model.Code &&
      this.model.Code.toString().length >= this.selectedgeneralLedgerCodeLen + 1 &&
      this.model.Code.toString().length <= this.selectedgeneralLedgerCodeLen + this.selectedSubLedgerCodeLen &&
      this.model.Code.toString().substring(0, this.selectedgeneralLedgerCodeLen) === this.model.GeneralLedgerCode.toString();
    if (!result) this.formGroup.controls["Code"].setErrors({ customerror: `${this.translate("ClientApp.BackOffice.ACC.SubLedger.SubLedgerWrong")}` });
    return result;
  }

  setColumnAttribute() {
    const dlLevel = this.detailLedgerLevel;
    this.orignalColumns.forEach((x) => {
      if (x.name === "GeneralLedgerId") x.disabled = !this.isNewRow;
      if (x.name === "HasDetailLedger1") x.formVisible = dlLevel >= 1;
      if (x.name === "HasDetailLedger2") x.formVisible = dlLevel >= 2;
      if (x.name === "HasDetailLedger3") x.formVisible = dlLevel >= 3;
      if (x.name === "HasDetailLedger4") x.formVisible = dlLevel >= 4;
      if (x.name === "HasDetailLedger5") x.formVisible = dlLevel >= 5;
      if (x.name === "HasDetailLedger6") x.formVisible = dlLevel >= 6;
      if (x.name === "HasDetailLedger7") x.formVisible = dlLevel >= 7;
    });
    let minfprmat = [10, 100, 1000, 10000, 100000, 1000000];
    let maxfprmat = [9, 99, 999, 9999, 99999, 999999];
    this.columns.forEach((x) => {
      if (x.name === "GroupLedgerId") x.disabled = !this.isNewRow;
      if (x.name === "Code" && this.model.GeneralLedgerCode) {
        x.min = this.model.GeneralLedgerCode * minfprmat[this.selectedSubLedgerCodeLen - 1];
        x.max = Number(this.model.GeneralLedgerCode.toString() + maxfprmat[this.selectedSubLedgerCodeLen - 1].toString());
        if (this.formGroup.get("Code")) {
          let validator: ValidatorFn[] = [];
          if (x.required && !x.disabled) validator.push(Validators.required);
          if (x.max && x.max > 0) validator.push(Validators.max(x.max));
          if (x.min && x.min > 0) validator.push(Validators.min(x.min));
          this.formGroup.get("Code").setValidators(validator);
        }
      }
    });
  }
}
